import React from "react";
import { Helmet } from "react-helmet-async";
import { Link, useLocation } from "react-router-dom";

import styled from "styled-components";

//Import Custom Component
// import NewsletterModal from '../features/modal/newsletter-modal';
import PopularProducts from "./collection/popular-products";
//import WishlistCollection from './wishlist-collection';
import HomeSlide from "./home-slide";
import ManufacturersCollection from "./collection/manufacturers-collection";
import Carousel from "../features/carousel";
import ProductsGroups from "./collection/product-groups";

//Import Settings
import { owlSetting4 } from "../../utils/settings";

//Import Data
import data from "../../mock-data/data.json";
import { useCallback } from "react";
import { useCanonicalLink } from "../../utils/useCanocialLink";

function HomePage() {
  const canonicalLink = useCanonicalLink();

  return (
    <>
      <Helmet>
        <title>
          Buduj.pl - Sklep online z materiałami budowlanymi na Twoją budowę
        </title>
        <meta
          name="description"
          content="Sklep online - sprzedaż materiałów budowlanych poprzedzona 20-letnim doświadczeniem. Działamy tylko na tym terenie gdzie dostawa naszym transportem jest opłacalna dla kupującego."
        />
        <meta
          name="keywords"
          content="budowa domu,remont,materiały budowlane,wełna mineralna,kostka brukowa,market budowlany,skład budowlany,beton komórkowy,wełna szklana,suporeks,fundamenty,instalacje wodne,instalacje elektryczne,technika grzewcza i ogrzewanie,instalacje kominkowe,instalacja elektryczna,elewacja,karton gips,tynk,glazura,terakota,łazienka,sypialnia,urządzanie mieszkania,ogrody przydomowe,nawadnianie ogrodu,zakładanie trawnika,projekty domów,projekty wnętrz,projekty ogrodów,węgiel,drewno,ekogroszek,gaz,brykiet,pellet"
        />
        <link rel="canonical" href={canonicalLink} />
      </Helmet>

      <div className="main home">
        {/* <div className="home-top-container">
          <Carousel
            addClass="home-slider owl-carousel-lazy"
            settings={{ loop: true, lazyLoad: true }}
          >
            {data.homeBanners.map((item, index) => (
              <HomeSlide data={item} key={"HomeSlide" + index} />
            ))}
          </Carousel>
        </div> */}
        <div className="container">

          <StyledH1 >
            Hurtownia materiałów budowlanych online z dostawą na Twoją budowę
          </StyledH1>
        </div>

        <section className="categories-container">
          <ProductsGroups />
        </section>

        {/* <section className="product-panel mt-1 mb-1">
          <WishlistCollection addClass="row row-sm" title="Ulubione" />
        </section> */}

        <section className="product-panel mt-3">
          <PopularProducts title="Popularne produkty" />
        </section>

        {/* <section className="categories-container">
          <Carousel
            addClass="container categories-carousel"
            settings={owlSetting4}
          >
            {data.categories.map((banner, index) => (
              <Link to={`${process.env.PUBLIC_URL}/${banner.path}`} key={index}>
                <div className="category" key={"Category" + index}>
                  <i className={banner.icon}></i>
                  <span>{banner.title}</span>
                </div>
              </Link>
            ))}
          </Carousel>
        </section> */}

        <section className="info-section">
          <div className="container">
            <div className="row justify-content-center">
              {data.info.map((info, index) => (
                <div className="col-md-4" key={index}>
                  <div className="info-box">
                    <i className={info.name}></i>
                    <div className="info-box-content">
                      <h4 className="mb-2" style={{ fontSize: "2rem", fontWeight: "500" }}>{info.title}</h4>
                      <p>{info.text}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* <section className="categories-container">
          <div className="container text-center">
            <div className="col-lg-8 m-auto">
              <video style={{width: '100%'}} src={`${process.env.PUBLIC_URL}/assets/video/buduj.mp4`} controls></video>
              <video src={`${process.env.PUBLIC_URL}/assets/video/wypozyczalnia.mp4`} controls className="mw-100"></video>
            </div>
          </div>
        </section> */}

        <section className="mt-3 mb-3" id="topBrands">
          <ManufacturersCollection />
        </section>
      </div>

      {/* <NewsletterModal /> */}
    </>
  );
}

const StyledH1 = styled.h1`
  font-size: 1.8rem;
  font-weight: 600;
  text-align: center;
  margin-block: 1.5rem;
  color: #777;
`;

export default HomePage;
